import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './navbar.css';
import logo from './logo.png';

const Navbar = () => {
  const { i18n, t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [selectedLang, setSelectedLang] = useState(i18n.language || 'en');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const changeLanguage = (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    setSelectedLang(language);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`site-nav ${scrolled ? 'site-nav--scrolled' : ''}`} aria-label="Primary navigation">
      <div className="container site-nav__inner">
        <a className="site-nav__brand" href="#header" onClick={closeMenu} aria-label="NIEC Indonesia home">
          <img src={logo} alt="NIEC Indonesia, Super Student, and Immerse Education" />
        </a>

        <button
          className="site-nav__toggle"
          type="button"
          aria-label={menuOpen ? t('navbar.close_menu') : t('navbar.open_menu')}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((value) => !value)}
        >
          <i className={`fa-solid ${menuOpen ? 'fa-xmark' : 'fa-bars'}`} aria-hidden="true" />
        </button>

        <div className={`site-nav__menu ${menuOpen ? 'site-nav__menu--open' : ''}`}>
          <a href="#header" onClick={closeMenu}>{t('navbar.nav1')}</a>
          <a href="#info-beasiswa" onClick={closeMenu}>{t('navbar.nav2')}</a>
          <a href="#tahapan" onClick={closeMenu}>{t('navbar.nav3')}</a>
          <select
            className="site-nav__language"
            value={selectedLang}
            onChange={changeLanguage}
            aria-label={t('navbar.language')}
          >
            <option value="en">EN</option>
            <option value="id">ID</option>
          </select>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
